import BeautyInsiderBirthdayGifts from './BeautyInsiderBirthdayGifts.f';
import { withBeautyInsiderBirthdayGiftsProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderBirthdayGiftsProps';

export default withBeautyInsiderBirthdayGiftsProps(BeautyInsiderBirthdayGifts);
